import {
  buildGoogleCalendarUrl as buildSharedGoogleCalendarUrl,
  downloadIcsEvent,
  escapeIcsText,
  serializeIcsEvent,
  type CalendarEventExport,
} from "../../../utils/calendarEventExport";
import { isDateOnlyStart, startDateInSchoolZone } from "../../../features/schoolTasks/taskStart";

export interface SchoolTaskCalendarItem {
  id: string;
  title: string;
  startsAt: string;
  endsAt?: string | null;
  description?: string | null;
  location?: string | null;
  url?: string | null;
}

const schoolTaskIcsOptions = {
  productId: "-//Lumen//School Tasks//NL",
  method: "PUBLISH",
};

const validEnd = (item: SchoolTaskCalendarItem) => {
  if (!item.endsAt) return null;
  const start = new Date(item.startsAt).getTime();
  const end = new Date(item.endsAt).getTime();
  return Number.isFinite(start) && Number.isFinite(end) && end > start
    ? item.endsAt
    : null;
};

export const buildSchoolTaskIcs = (item: SchoolTaskCalendarItem) => {
  return serializeIcsEvent(toCalendarEvent(item), schoolTaskIcsOptions);
};

export const buildGoogleCalendarUrl = (item: SchoolTaskCalendarItem) => {
  return buildSharedGoogleCalendarUrl(toCalendarEvent(item), {
    timeZone: "Europe/Amsterdam",
  });
};

export const downloadSchoolTaskIcs = (item: SchoolTaskCalendarItem) => {
  downloadIcsEvent(
    toCalendarEvent(item),
    `school-task-${item.id}.ics`,
    schoolTaskIcsOptions,
  );
};

// A task with only a date (midnight in Amsterdam) becomes an all-day event instead of one at 00:00.
const toCalendarEvent = (item: SchoolTaskCalendarItem): CalendarEventExport => ({
  uid: `school-task-${escapeIcsText(item.id)}@lumen`,
  title: item.title,
  startsAt: item.startsAt,
  endsAt: validEnd(item),
  allDayDate: isDateOnlyStart(item.startsAt) ? startDateInSchoolZone(item.startsAt) : null,
  description: item.description,
  location: item.location,
  url: item.url,
});
